import { useTranslation } from 'react-i18next'

import { fmtDate } from '../../utils/fmtDate'
import styles from './AssignmentsTable.module.scss'

export const AvailableTable = ({ items, onOpen }) => {
  const { t } = useTranslation('common')
  return (
    <table className="unv-table">
      <thead>
        <tr>
          <th>{t('assignments.col_title')}</th>
          <th>{t('assignments.col_subject')}</th>
          <th>{t('assignments.col_kind')}</th>
          <th>{t('assignments.col_deadline')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {items.map((a) => (
          <tr key={a.id}>
            <td>{a.title}</td>
            <td>{a.subject_name || a.subject?.name || '—'}</td>
            <td>{a.kind || '—'}</td>
            <td>{fmtDate(a.due_at)}</td>
            <td>
              <button className="unv-btn" onClick={() => onOpen(a)}>
                {t('assignments.open_btn')}
              </button>
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan="5" className={styles.empty}>{t('assignments.no_available')}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export const MySubmissionsTable = ({ items, onOpen }) => {
  const { t } = useTranslation('common')
  return (
    <table className="unv-table">
      <thead>
        <tr>
          <th>{t('assignments.col_assignment')}</th>
          <th>{t('assignments.col_status')}</th>
          <th>{t('assignments.col_grade')}</th>
          <th>{t('assignments.col_submitted')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {items.map((s) => (
          <tr key={s.id}>
            <td>{s.assignment_title || s.assignment?.title || '—'}</td>
            <td><span className="unv-badge">{s.status}</span></td>
            <td>{s.grade ?? '—'}</td>
            <td>{fmtDate(s.submitted_at)}</td>
            <td>
              <button className="unv-btn unv-btn--ghost" onClick={() => onOpen(s)}>
                {t('assignments.open_btn')}
              </button>
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan="5" className={styles.empty}>{t('assignments.no_my_subs')}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export const MyTasksTable = ({ items }) => {
  const { t } = useTranslation('common')
  return (
    <table className="unv-table">
      <thead>
        <tr>
          <th>{t('assignments.col_title')}</th>
          <th>{t('assignments.col_subject')}</th>
          <th>{t('assignments.col_group')}</th>
          <th>{t('assignments.col_published')}</th>
          <th>{t('assignments.col_deadline')}</th>
        </tr>
      </thead>
      <tbody>
        {items.map((a) => (
          <tr key={a.id}>
            <td>{a.title}</td>
            <td>{a.subject_name || a.subject?.name || '—'}</td>
            <td>{a.group_name || a.group?.name || '—'}</td>
            <td>{a.is_published ? t('assignments.yes_short') : t('assignments.no_short')}</td>
            <td>{fmtDate(a.due_at)}</td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan="5" className={styles.empty}>{t('assignments.no_my_tasks')}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export const ReviewQueueTable = ({ items, onOpen }) => {
  const { t } = useTranslation('common')
  return (
    <table className="unv-table">
      <thead>
        <tr>
          <th>{t('assignments.col_student')}</th>
          <th>{t('assignments.col_assignment')}</th>
          <th>{t('assignments.col_submitted')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {items.map((s) => (
          <tr key={s.id}>
            <td>{s.student_name || s.student?.full_name || '—'}</td>
            <td>{s.assignment_title || s.assignment?.title || '—'}</td>
            <td>{fmtDate(s.submitted_at)}</td>
            <td>
              <button className="unv-btn" onClick={() => onOpen(s)}>
                {t('assignments.review_btn')}
              </button>
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan="4" className={styles.empty}>{t('assignments.queue_empty')}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
